<template>
  <section>
    <div id="table" class="col-12 px-0 d-flex flex-column position-relative z-1">
      <div class="form-inline mb-sm-3 d-flex justify-content-between">

        <advancedFilter v-if="options.advancedFilter" :loaded="options.loaded" />

        <rowsFilter v-if="options.filter" :options="options" :activeFilter="activeFilter"
          @setFilter="setActiveFilter($event)" />

        <div class="form-group col-12 col-lg-auto mt-2 mt-lg-0 mt-xl-0 ml-auto px-0 action_section">
          <search :options="options" :search="search" @search="search = $event" v-if="options.search" />
          <router-link tag="button" :to="{ name: 'Add Admin Members' }"
            class="btn d-none d-md-block btn-primary mt-2 mt-sm-0" v-if="options.addAdmin">Add Admin</router-link>
          <router-link tag="button" :to="{ name: 'Add Secretary Members' }"
            class="btn d-none d-md-block btn-primary mt-2 mt-sm-0" v-if="options.addSecretary">Add
            Secretary</router-link>
          <router-link tag="button"
            :to="{ name: (userRole === 'Admin' || userRole === 'SuperAdmin') ? 'Add Horses' : (userRole === 'Member' || userRole === 'Volunteer') ? 'Add Horse' : 'Secretary Add Horses' }"
            class="btn btn-fz-sm btn-primary d-block px-xl-5 mt-2 mt-sm-0 ml-md-0"
            v-if="options.addHorse && !options.hideHorses">Add<span class="d-inline"> Horse</span></router-link>
          <router-link tag="button" :to="{ name: 'Create Draft' }"
            class="btn d-none d-md-block btn-primary px-lg-3 px-xl-5 mt-2 mt-sm-0" v-if="options.addDraft">Create<span
              class="d-none d-xl-inline"> Draft</span></router-link>
          <router-link tag="button" :to="{ name: 'Committee Profile' }"
            class="btn d-none d-md-block btn-primary px-xl-5 mt-2 mt-sm-0" v-if="options.addCommittee">Add<span
              class="d-none d-xl-inline"> Committee</span></router-link>
        </div>
      </div>

      <datatable :columns="visibleColumns" :data="filtering ? filteredRows : dataRows" :filter-by="search"
        :class="['position-relative z-0 table-headers-sticky', dataRows.length === 0 ? 'mb-0' : '']">
        <template slot-scope="{ row }">
          <tr v-if="$store.state.showExpand && !options.disableExpand">
            <td colspan="100%">
              <div
                :class="['d-flex justify-content-between align-items-center position-relative', options.flexWrap ? 'flex-wrap' : '']">
                <slot name="expandedSelect" :row="row"></slot>
                <slot name="expandedHeader" :row="row"></slot>
                <slot name="expandedCustom" :row="row"></slot>
                <button slot="expandToggle" class="btn btn-xs btn-link position-relative z-1" @click="expand(row.id)">
                  <svg v-if="expanded == row.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 6" width="13"
                    height="6">
                    <rect width="100%" height="100%" fill="none" />
                    <g class="currentLayer">
                      <path fill="#231815"
                        d="M12.6 6h-.4L7.6 1.4C7 .8 6 .8 5.5 1.4L.9 6c-.2.2-.5.2-.7 0s-.2-.5 0-.7L4.8.7c.9-1 2.6-1 3.5 0l4.6 4.6c.2.2.2.5 0 .7h-.3z" />
                    </g>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 6" width="13" height="6">
                    <rect width="100%" height="100%" fill="none" />
                    <g class="currentLayer">
                      <path fill="#231815"
                        d="M6.5 6.2c-.7 0-1.3-.3-1.8-.7L.1.9C0 .7 0 .4.1.2s.5-.2.7 0l4.6 4.6c.6.6 1.5.6 2.1 0L12.1.2c.2-.2.5-.2.7 0s.2.5 0 .7L8.2 5.5c-.4.4-1 .7-1.7.7z" />
                    </g>
                  </svg>
                </button>
              </div>
              <slot name="expandedRow" :row="row" v-if="expanded === row.id"></slot>
            </td>
          </tr>
          <tr v-else>
            <template v-for="(column, j) in visibleColumns">
              <datatable-cell v-if="!column.hidden" :key="j" :column="column" :row="row"></datatable-cell>
            </template>
          </tr>
        </template>
        <template slot="footer" slot-scope="{ rows }">
          <tr>
            <td colspan="100%" class="p-0 border-0">
              <div class="text-center py-2" v-if="dataRows.length === 0 && options.loaded !== true">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div class="alert alert-warning rounded-0 mb-0"
                v-if="(dataRows.length > 0 || options.loaded) && rows ? rows.length === 0 : false">There are no results.
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
    <div class="form-inline justify-content-between align-items-start">
      <show-entries v-if="dataRows.length > 20" @perPage="per_page = Number($event)" />
      <div class="d-block d-md-none text-center mb-2 flex-grow-1">
        Showing {{ per_page > (rowsLength === 0 ? dataRows.length : rowsLength) ? (rowsLength === 0 ? dataRows.length :
          rowsLength) : per_page }} rows of {{ rowsLength === 0 ? dataRows.length : rowsLength }}
      </div>
      <div class="pagination-container form-group align-items-start justify-content-center"
        v-show="dataRows.length > per_page">
        <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import eventBus from '@/store/EventBus.js'
import DatatableFactory from 'vuejs-datatable'

import rowsFilter from '@/components/DataTableFields/Filter'
import advancedFilter from '@/components/DataTableFields/AdvancedFilter'
import search from '@/components/DataTableFields/Search'
import showEntries from '@/components/DataTableFields/ShowEntries'

Vue.use(DatatableFactory)

export default {
  props: {
    dataRows: Array,
    dataColumns: Array,
    options: Object,
    // Optional (filterKey, value) => boolean|Promise<boolean> - return false to block the tab switch
    filterGuard: { type: Function, default: null }
  },
  components: {
    rowsFilter,
    advancedFilter,
    search,
    'show-entries': showEntries
  },
  model: {
    prop: 'page',
    event: 'change'
  },
  methods: {
    expand(id) {
      if (this.expanded === id) {
        this.expanded = null
        return
      }
      this.expanded = id
    },
    async setActiveFilter(updatedFilter) {
      if (this.filterGuard && !(await this.filterGuard(updatedFilter.filterKey, updatedFilter.filterChosen))) {
        return
      }
      this.activeFilter[updatedFilter.filterKey] = updatedFilter.filterChosen
    },
    colorTableFields() {
      const tables = document.querySelectorAll('tbody')
      tables.forEach((table) => {
        const cellsHtmlCollection = table.getElementsByTagName('tr')
        const cells = this.htmlCollectionToArray(cellsHtmlCollection)
        cells.forEach((cell) => {
          const parity = cell.querySelector('.js-parity')?.dataset?.parity
          if (!parity) {
            return
          }
          if (parity === 'even') {
            cell.classList.remove('row-even')
            cell.classList.add('row-odd')
          } else {
            cell.classList.remove('row-odd')
            cell.classList.add('row-even')
          }
        })
      })
    },
    htmlCollectionToArray(htmlCollection) {
      const array = []
      for (let i = 0; i < htmlCollection.length; i++) {
        array.push(htmlCollection[i])
      }
      return array
    }
  },
  data() {
    return {
      search: '',
      activeFilter: this.options.activeFilter,
      filtering: this.options.activeFilter ? !Object.keys(this.options.activeFilter).every(filter => this.options.activeFilter[filter] === 'all') : false,
      advancedFilterOpen: false,
      columns: this.dataColumns,
      page: 1,
      per_page: 20,
      selected_rows: [],
      expanded: null,
      rowsLength: 0,
      userRole: localStorage.role
    }
  },
  watch: {
    activeFilter: {
      handler() {
        this.filtering = !Object.keys(this.activeFilter).every(filter => this.activeFilter[filter] === 'all')
      },
      deep: true
    },

    search() {
      // add searching event on all tables on page
      if (this.options.searchOnAllTables) {
        this.$root.$emit('search', this.search)
      }
    }
  },
  computed: {
    filteredRows() {
      // eslint-disable-next-line
      const filteredRows = this.dataRows.filter((row) => {
        // eslint-disable-next-line
        return this.options.activeFilter && Object.keys(this.options.activeFilter).filter((activeFilter) => {
          return (
            this.options.activeFilter[activeFilter] === row[activeFilter] && row.role !== 'Volunteer') ||
            this.options.activeFilter[activeFilter] === 'all' ||
            (this.options.activeFilter[activeFilter] === true && typeof row[activeFilter] === 'string') ||
            (this.options.activeFilter[activeFilter] === row.role && this.options.activeFilter[activeFilter] !== 0 && this.options.activeFilter[activeFilter] !== 1
            )
        }).length === Object.keys(this.options.activeFilter).length
      })
      this.rowsLength = filteredRows.length
      return filteredRows
    },
    visibleColumns() {
      return this.columns.filter(column => column.visible)
    }
  },
  created() {
    eventBus.$on('selected', (row) => {
      if (!this.selected_rows.includes(row)) {
        this.selected_rows.push(row)
      }
    })

    eventBus.$on('selected_rows', (selected_rows) => {
      this.selected_rows = selected_rows
    })

    eventBus.$on('deselected', (row) => {
      if (this.selected_rows.includes(row)) {
        const index = this.selected_rows.indexOf(row)

        this.selected_rows.splice(index, 1)
      }
    })

    eventBus.$on('deselect-all', () => {
      this.$store.commit('deselectAllRows')
      this.selected_rows = this.$store.getters.selectedRows
      // Vue.set(this, 'selected_rows', [])
    })

    /*
      search listener
      set search value for all tables
     */
    this.$root.$on('search', (value) => {
      this.search = value
    })
  },
  updated() {
    if (this.options && this.options.groupByZone === true) {
      this.colorTableFields()
    }
    if (this.filteredRows.length > 0 && this.page === 0) {
      this.page = 1
    }
  }
}
</script>

<style lang="scss" scoped>
#entireAacJudgesPanel .action_section {
  display: none;
  background: aqua;
}
</style>



// WEBPACK FOOTER //
// src/components/DataTable.vue